module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "newsForm",
    attrs: {
      "model": _vm.newsData,
      "rules": _vm.validateRules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题",
      "prop": "newsContentTitle"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "新闻标题（必填）"
    },
    model: {
      value: (_vm.newsData.newsContentTitle),
      callback: function($$v) {
        _vm.newsData.newsContentTitle = $$v
      },
      expression: "newsData.newsContentTitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "来源",
      "prop": "newsContentSource"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "新闻来源（必填）"
    },
    model: {
      value: (_vm.newsData.newsContentSource),
      callback: function($$v) {
        _vm.newsData.newsContentSource = $$v
      },
      expression: "newsData.newsContentSource"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.lunboSlideNum), function(i) {
    return [_c('el-form-item', {
      staticClass: "yd-lunbo-vertical-long-words",
      staticStyle: {
        "margin-bottom": "10px"
      },
      attrs: {
        "label": "图片（尺寸3:4）",
        "prop": "newsContentImage"
      }
    }, [_c('el-input', {
      attrs: {
        "auto-complete": "off",
        "placeholder": "图片链接（必填）"
      },
      on: {
        "blur": function($event) {
          _vm.lunboImgsBlur(i - 1)
        }
      },
      model: {
        value: (_vm.lunboImages[i - 1]),
        callback: function($$v) {
          var $$exp = _vm.lunboImages,
            $$idx = i - 1;
          if (!Array.isArray($$exp)) {
            _vm.lunboImages[i - 1] = $$v
          } else {
            $$exp.splice($$idx, 1, $$v)
          }
        },
        expression: "lunboImages[i-1]"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticStyle: {
        "margin-bottom": "18px"
      },
      attrs: {
        "label": "落地页",
        "prop": "lunboURLs"
      }
    }, [_c('el-input', {
      attrs: {
        "auto-complete": "off",
        "placeholder": "网站链接（选填）"
      },
      model: {
        value: (_vm.lunboURLs[i - 1]),
        callback: function($$v) {
          var $$exp = _vm.lunboURLs,
            $$idx = i - 1;
          if (!Array.isArray($$exp)) {
            _vm.lunboURLs[i - 1] = $$v
          } else {
            $$exp.splice($$idx, 1, $$v)
          }
        },
        expression: "lunboURLs[i-1]"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "描述",
        "prop": "lunboInfos"
      }
    }, [_c('el-input', {
      attrs: {
        "auto-complete": "off",
        "placeholder": "描述内容（选填）"
      },
      model: {
        value: (_vm.lunboInfos[i - 1]),
        callback: function($$v) {
          var $$exp = _vm.lunboInfos,
            $$idx = i - 1;
          if (!Array.isArray($$exp)) {
            _vm.lunboInfos[i - 1] = $$v
          } else {
            $$exp.splice($$idx, 1, $$v)
          }
        },
        expression: "lunboInfos[i-1]"
      }
    })], 1)]
  }), _vm._v(" "), (_vm.isEdit) ? _c('el-form-item', {
    attrs: {
      "label": "置顶权重",
      "prop": "newsContentIsTop"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newsData.newsContentIsTop),
      callback: function($$v) {
        _vm.newsData.newsContentIsTop = $$v
      },
      expression: "newsData.newsContentIsTop"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button-group', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addSlide
    }
  }, [_vm._v("添加slide")]), _vm._v(" "), (_vm.lunboSlideNum > 1) ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.delSlide
    }
  }, [_vm._v("删除slide")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.newsFormSubmit
    }
  }, [_vm._v("提交")]), _vm._v(" "), (_vm.addForm) ? _c('el-button', {
    on: {
      "click": _vm.newsFormReset
    }
  }, [_vm._v("重置")]) : _c('el-button', {
    on: {
      "click": _vm.newsFormCancle
    }
  }, [_vm._v("取消")])], 1)], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-ef01206c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/market/common/newsAddForm/SlidesNewsVertical.vue
// module id = 799
// module chunks = 1